import React from "react";
import { motion } from "framer-motion";

// Shared button used across the site. Replaces the several spots that hard-coded
// style={{ backgroundColor: "rgb(79 70 229 / var(--tw-bg-opacity, 1))" }} instead of
// just a Tailwind class (a copy-pasted workaround from an older build).
const VARIANTS = {
  primary:
    "bg-brand-600 text-white hover:bg-brand-700 shadow-soft disabled:bg-brand-300",
  secondary:
    "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 disabled:text-gray-400",
  ghost: "bg-transparent text-brand-600 hover:bg-brand-50 disabled:text-gray-400",
};

const SIZES = {
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-sm",
  lg: "px-6 py-3 text-base",
};

const Button = React.forwardRef(function Button(
  { as = "button", variant = "primary", size = "md", className = "", children, ...props },
  ref
) {
  const Component = motion[as] || motion.button;
  return (
    <Component
      ref={ref}
      whileHover={{ scale: props.disabled ? 1 : 1.02 }}
      whileTap={{ scale: props.disabled ? 1 : 0.98 }}
      className={`inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors duration-150 disabled:cursor-not-allowed ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || SIZES.md} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
});

export default Button;
